import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './../../resources/configuracion/material.module';
import { Ng2Webstorage } from 'ngx-webstorage';
import { RecaptchaModule } from 'angular-google-recaptcha';
import { HttpClientModule } from '@angular/common/http';

import { IntegradorModule } from './../../resources/modules/integrador.module';

import { AppRoutingModule } from './recuperar-pass-routing.module';
import { MenuComponent } from './components/menu/menu.component';
import { ContenedorComponent } from './components/contenedor/contenedor.component';
import { CambiarPassComponent } from './components/cambiar-pass/cambiar-pass.component';
import { AutenticacionComponent } from './components/autenticacion/autenticacion.component';
import { ConfirmacionComponent } from './components/confirmacion/confirmacion.component';
import { NotificationsComponent } from './../../resources/components/notifications/notifications.component';
import { RecuperarCuentaGuard } from './../../resources/guards/recuperar-cuenta.guard';
import { environment } from './../../../environments/environment';
import { CondicionesComponent } from './components/condiciones/condiciones.component';
import { PassFirmaComponent } from './components/pass-firma/pass-firma.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    HttpModule, 
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    IntegradorModule,
    AppRoutingModule,
    Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    }),
    RecaptchaModule.forRoot({
      siteKey: environment.captchaKey
    })
  ],
  declarations: [    
  	MenuComponent,
    ContenedorComponent,
    AutenticacionComponent,    
    ConfirmacionComponent,
    CambiarPassComponent,
    NotificationsComponent,
    CondicionesComponent,
    PassFirmaComponent
  ],
  providers: [
    RecuperarCuentaGuard
  ],
  entryComponents: [
    NotificationsComponent,
    CondicionesComponent
  ]
})
export class RecuperarPassModule { }



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/recuperar-pass.module.ts